var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { AuthService } from '@app/auth.service';
import { UserService } from '@app/user.service';
var ProfileComponent = /** @class */ (function () {
    function ProfileComponent(Api, Auth, UserService, Util) {
        this.Api = Api;
        this.Auth = Auth;
        this.UserService = UserService;
        this.Util = Util;
    }
    ProfileComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.Auth.CheckSessionState()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.GetProfile()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProfileComponent.prototype.GetProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var Profile, Team, Role;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.Auth.GetProfile(localStorage.getItem("AgentBank_Profile"))];
                    case 1:
                        Profile = _a.sent();
                        Profile = Profile[0];
                        $('#txtName').val(Profile["dpa_name"]);
                        $('#txtEmail').val(Profile["dpa_emailaddress"]);
                        $('#txtPhoneNo').val(Profile["dpa_telephoneno"]);
                        if (!(Profile["dpa_teamid"] != null)) return [3 /*break*/, 3];
                        Team = {};
                        return [4 /*yield*/, this.Api.get("master", "agentBankTeam")];
                    case 2:
                        Team = _a.sent();
                        if (Team["length"] != 0) {
                            $('#txtTeam').val(Team.filter(function (a) { return a["dpa_agentbankteamid"] == Profile["dpa_teamid"]; })[0]["dpa_name"]);
                        }
                        _a.label = 3;
                    case 3:
                        Role = {};
                        return [4 /*yield*/, this.Auth.GetRole(Profile["dpa_roleid"])];
                    case 4:
                        Role = _a.sent();
                        if (Role[0]["dpa_access_changepassword"] == false) {
                            $('#btnChangePwd').addClass("hidden");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ProfileComponent.prototype.ChangePassword = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.Auth.CheckSessionState())
                    return [2 /*return*/];
                $('#txtCurrPwd').val('');
                $('#txtNewPwd').val('');
                $('#txtConfirmPwd').val('');
                $('#lblPwdError').html('');
                $('#dlgChngPwd').modal({
                    backdrop: 'static',
                    keyboard: false
                });
                return [2 /*return*/];
            });
        });
    };
    ProfileComponent.prototype.SavePassword = function () {
        return __awaiter(this, void 0, void 0, function () {
            var CurrPwd, NewPwd, Profile, Res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.Auth.CheckSessionState())
                            return [2 /*return*/];
                        CurrPwd = $('#txtCurrPwd').val();
                        NewPwd = $('#txtNewPwd').val();
                        return [4 /*yield*/, (this.Auth.GetProfile(localStorage.getItem("AgentBank_Profile")))];
                    case 1:
                        Profile = _a.sent();
                        if (CurrPwd == "") {
                            $('#lblPwdError').html('**กรุณาระบุรหัสผ่านปัจจุบัน');
                            return [2 /*return*/];
                        }
                        // if (CurrPwd != Profile[0]["dpa_password"]) {
                        //   $('#lblPwdError').html('**รหัสผ่านปัจจุบันไม่ถูกต้อง');
                        //   return;
                        // }
                        if (NewPwd == "") {
                            $('#lblPwdError').html('**กรุณาระบุรหัสผ่านใหม่');
                            return [2 /*return*/];
                        }
                        if (NewPwd == CurrPwd) {
                            $('#lblPwdError').html('**กรุณาระบุรหัสผ่านใหม่ให้ต่างจากรหัสผ่านปัจจุบัน');
                            return [2 /*return*/];
                        }
                        if (!this.UserService.IsValidatePassword(NewPwd)) {
                            $('#lblPwdError').html('**รหัสผ่านใหม่ไม่ตรงตามข้อกำหนด');
                            return [2 /*return*/];
                        }
                        if ($('#txtNewPwd').val() != $('#txtConfirmPwd').val()) {
                            $('#lblPwdError').html('**กรุณายืนยันรหัสผ่านให้ตรงกัน');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.UserService.ChangePassword(localStorage.getItem("AgentBank_Profile"), CurrPwd, NewPwd)];
                    case 2:
                        Res = _a.sent();
                        if (Res["RESMSG"] == "SUCCESS") {
                            //let Profile = await this.Auth.GetProfile(UserName);
                            //localStorage.setItem("AgentBank_Profile", JSON.stringify(Profile));
                            this.Util.SuccessDialog("บันทึกสำเร็จ");
                            setTimeout(function () {
                                $('#btnCloseDlg').click();
                            }, 500);
                        }
                        else {
                            $('#lblPwdError').html('');
                            this.Util.ErrorDialog("เปลี่ยนรหัสผ่านไม่สำเร็จ");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ProfileComponent;
}());
export { ProfileComponent };



// WEBPACK FOOTER //
// ./src/app/profile/profile.component.ts.pre-build-optimizer.js